module.exports = __webpack_public_path__ + "img/Aries.91bd8851.svg";